import { colors } from '../../Colors/colors'

export const entityConditionTheme = {
   light: {
      addConditionModal: {
         headingText: 'text-gray-900',
         descriptionText: 'text-gray-600',
         conditionText: 'text-gray-700',
         conditionBorder: 'border-gray-300',
         backgroundColor: 'bg-white',
         selectedConditionsCountText: 'text-gray-600',
         footerBg: 'bg-gray-50'
      }
   },
   dark: {}
}
